(function () {
  var isBusiness = !!window.__OU_IS_BUSINESS__;

  function setVisibility(el, show) {
    if (!el) return;
    if (show) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  }

  function updateUi(quoteRequired) {
    var noticeEls = document.querySelectorAll('[data-ou-quote-cart-notice]');
    noticeEls.forEach(function (el) {
      setVisibility(el, quoteRequired);
    });

    var standardEls = document.querySelectorAll('[data-ou-checkout-standard]');
    standardEls.forEach(function (el) {
      setVisibility(el, !quoteRequired);
    });

    var quoteEls = document.querySelectorAll('[data-ou-checkout-quote]');
    quoteEls.forEach(function (el) {
      setVisibility(el, quoteRequired);
    });
  }

  fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var hasNonStock = items.some(function (item) {
        return ((item.product_type || '') + '').toLowerCase() !== 'stock';
      });

      var quoteRequired = isBusiness || hasNonStock;
      updateUi(quoteRequired);

      var desiredQuoteRequired = quoteRequired ? 'true' : '';
      var desiredBusiness = isBusiness ? 'true' : '';
      var currentAttributes = (cart && cart.attributes) ? cart.attributes : {};
      var currentQuoteRequired = currentAttributes.quote_required || '';
      var currentBusiness = currentAttributes.customer_is_business || '';

      if (
        currentQuoteRequired !== desiredQuoteRequired ||
        currentBusiness !== desiredBusiness
      ) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              quote_required: desiredQuoteRequired,
              customer_is_business: desiredBusiness
            }
          })
        });
      }

      return null;
    })
    .catch(function () {
      // No-op: cart or network unavailable.
    });
})();
